import styled from "styled-components";

export const Container = styled.div`
  cursor: pointer;
`;

export const GoButton = styled.img``;
